<template>
    <div class="pocket">
        <!-- 同 npcTaskDialog：append-to-body 让遮罩渲染到 body，避免被 street-anim 包含块裁剪及共享遮罩单例搬移遗留 -->
<el-dialog :top="dialogTop" customClass="wrap" title="我的背包" :close-on-click-modal="false" :visible.sync="pocketDialogTableVisible" :before-close="pocket_dialog_close" append-to-body>
            <div class="itembg">
            <div id="itemtitle">
                我的物品<label v-show="myPocketItems != null">（{{myPocketItems.length}}/{{POCKET_VOLUME}}）</label>
            </div>
            <div id="itemlist">
                <div v-show="myPocketItems != null" v-for="(item,index) in myPocketItems" v-bind:key="index" 
                ref="item" class="itemdiv" :id="item.itemId + '_item'">
                    <label :for="item.itemId">
                        <img :title="item.itemName" :src="ossPath + item.imgSrc">
                        <div v-if="item.stackCount != null" class="stackCount" v-text="item.stackCount"/>
                    </label>
                    <div class="opts">
                        <a @click="giveItemToNpc(item.itemId);">给出</a>
                    </div>
                </div>
            </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'npcPocketDialog',
  data() {
    return {
        myPocketItems: [],
        pocketDialogTableVisible: false,
        npcId: "",
        isMobile: window.innerWidth <= 768
    };
  },
  computed: {
    ...mapState('street', ['fantasyTaskTodoBOList']),
    dialogTop: function() {
      return this.isMobile ? '0' : '15vh';
    }
  },
  methods: {
    pocket_dialog_close() {
      this.pocketDialogTableVisible = false;
    },
    openPocket: function(npcId){
      const _this = this;
      this.pocketDialogTableVisible = true;
      this.myPocketItems = [];
      getRequest('/item/cabinet/openPocket', {
      }).then(resp=> {
        if (resp.status == 200) {
          //成功
            const respData = resp.data;
            if (200 == respData.status) {
                this.myPocketItems = respData.data.pocketItems;
                this.npcId = npcId;
            } else {
                this.pocketDialogTableVisible = false;
                Message.error(respData.message);
            }
        } else {
          //失败
          this.pocketDialogTableVisible = false;
          Message.error('用户非法⊙﹏⊙∥!');
        }
      }, resp=> {
        this.pocketDialogTableVisible = false;
        Message.error('用户非法⊙﹏⊙∥!');
      });
    },
    giveItemToNpc: function(itemId) {
        let _this = this;
        let npcId = this.npcId;
        this.pocketDialogTableVisible = false;
        // 打开交谈框并显示 loading
        _this.$emit('open-talk-loading');
        //先判断当前npc是否是玩家的目标
        let taskTo = false;
        let taskTodoId;
        for (let i=0; i<this.fantasyTaskTodoBOList.length; i++) {
            const fantasyTaskTodo = this.fantasyTaskTodoBOList[i];
            if (fantasyTaskTodo.taskTo == npcId && fantasyTaskTodo.taskStatus == 0
            && (fantasyTaskTodo.taskType == 2 || fantasyTaskTodo.taskType == 3)) {
                taskTo = true;
                taskTodoId = fantasyTaskTodo.id;
                break;
            }
        }

        if (true == taskTo) {
            //调用给npc道具方法，修改当前待办任务的状态为条件达成
            postRequest('/npc/npc/giveItemToNpc', {
                npcId: npcId,
                itemId: itemId
            }).then(resp=> {
                if (resp.status == 200) {
                    //成功
                    const respData = resp.data;
                    if (200 == respData.status) {
                        _this.$emit('task-finished', respData);
                    } else {
                        _this.$emit('show-talk-msg', respData.message);
                    }
                } else {
                    //失败
                    _this.$emit('show-talk-msg', respData.message);
                }
            }, resp=> {
                _this.$emit('close-talk');
                Message.error('用户非法⊙﹏⊙∥!');
            });
        } else {
            // 拜访型待办（type=1）：任务不要道具，提示去交谈而不是笼统拒绝（2026-10-01）
            let visitTodo = false;
            for (let i = 0; i < this.fantasyTaskTodoBOList.length; i++) {
                const t = this.fantasyTaskTodoBOList[i];
                if (t.taskTo == npcId && t.taskStatus == 0 && t.taskType == 1) {
                    visitTodo = true;
                    break;
                }
            }
            _this.$emit('show-talk-msg', visitTodo ? "这个任务不用给我道具——按任务要求做完，再来跟我交谈吧。" : "我不需要这个东西。");
        }
    }
  }
}
</script>

<style scoped>
a {
    cursor: pointer;
    color: blue;
}
{
    width:100%;
}
.wrap {
    margin:auto;
}
.itembg {
    width:100%;
    height: 400px;
}
#itemtitle {
    padding:3px 5px;
    background-color:#72b653;
    font-size:16px;
    font-weight:bold;
    color:#fff;
    letter-spacing:5px; 
    text-align:center;
}
#itemlist {
    padding:5px;
    text-align:center;
}
#itemcontrol {
    margin:5px;
    line-height: 40px;
    text-align: left;
}
#itemcontrol input,label,select {
    vertical-align:middle;
}
.itemdiv {
    height:80px;
    width:70px;
    float:left;
    position:relative;
    margin:5px;
}
.itemdiv input {
    position:absolute;
    top:0;
    left:0;
}
.itemdiv img {
    height:40px;
}
.itemdiv .stackCount {
  position: absolute;
  bottom: 20px;
  font-size: 0.7em;
  width: 100%;
  /* background-color: rgba(233, 141, 66, 0.4); */
}
.opts {
    position:absolute;
    display: none;
    background-color: #aaa;
    z-index: 10;
    width: 50px;
    border:1px solid #f00;
}
.opts a {
    display: block;
    padding: 5px;
    margin: auto;
    text-decoration: none;
}
.opts a:hover {
    text-decoration: underline;
    background-color: #666;
    color: #fff;
}
.itemdiv:hover .opts {
    display:block;
    position:absolute;
    top:30px;
    left:50px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  /* 背包弹窗 - 移动端卡片式网格 */
  .itembg {
    height: auto;
    max-height: 65vh;
    overflow-y: auto;
  }
  #itemtitle {
    font-size: 14px;
    letter-spacing: 1px;
    padding: 6px 4px;
  }
  #itemlist {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 6px;
    padding: 6px;
  }
  .itemdiv {
    width: auto;
    height: auto;
    float: none;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 2px 6px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fafafa;
    position: relative;
  }
  .itemdiv img {
    height: 36px;
    margin-bottom: 2px;
  }
  .itemdiv .stackCount {
    position: static;
    font-size: 0.7em;
    text-align: center;
    background: transparent;
    line-height: 1.2;
  }
  .opts {
    position: static;
    display: block;
    width: 100%;
    border: none;
    background: transparent;
    margin-top: 4px;
  }
  .opts a {
    display: block;
    padding: 6px 0;
    background: #409eff;
    color: #fff;
    border-radius: 3px;
    text-align: center;
    font-size: 12px;
    text-decoration: none;
  }
  .itemdiv:hover .opts {
    display: block;
    position: static;
    top: auto;
    left: auto;
  }
}
</style>